import { Bell } from "lucide-react";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { cn } from "@/lib/cn";
import { routes } from "@/lib/routes";

// Mobile top bar: page title on the left, notification bell (with unread badge) on the right.
export function TopBar({
  title,
  unread = 0,
  leading,
  className,
}: {
  title: ReactNode;
  unread?: number;
  leading?: ReactNode;
  className?: string;
}) {
  const { t } = useTranslation("translation", { keyPrefix: "common" });
  return (
    <header className={cn("sticky top-0 z-30 border-zinc-200 border-b bg-white", className)}>
      <div className="mx-auto flex h-14 max-w-2xl items-center gap-2 px-4">
        {leading}
        <h1 className="flex-1 truncate font-semibold text-lg">{title}</h1>
        <Link
          to={routes.notifications}
          aria-label={unread > 0 ? t("notificationsUnread", { count: unread }) : t("notifications")}
          className="relative -mr-2 flex size-11 items-center justify-center rounded-md text-zinc-700 hover:bg-zinc-100"
        >
          <Bell className="size-6" aria-hidden />
          {unread > 0 ? (
            <span className="absolute top-1.5 right-1.5 min-w-4 rounded-full bg-danger px-1 text-center font-semibold text-[10px] text-white leading-4">
              {unread > 9 ? "9+" : unread}
            </span>
          ) : null}
        </Link>
      </div>
    </header>
  );
}
